module.exports = __webpack_public_path__ + "img/cards-box-bg-tab.a6db4314.png";